//各个映射表，进系统时获取
const state = () => ({
  status: {},
  user: {},
  gate: {},
  expiredType: {},
  stateEquipmentType: {},
  documentType: {},
  entrancesType: {},
  gateType: {},
  driverType: {},
  areaType: {},
  carVisitType: {},
  personVisitType: {},
  delayedType: {},
  carModel: {},
  carModelObj: {},
  dept: {},
  noticeType: {},
  noticeStatus: {},
  plateColorType: {},
  blackWhiteListType: {},
  vehicleColorType: {},
  labelType: {},
  labelColor: {},
  labelStatus: {},
  labelAlarmType: {},
})
const mutations = {
  setStatus(state, payload) {
    state.status = { ...payload }
  },
  setLabelType(state, payload) {
    state.labelType = { ...payload }
  },
  setLabelColor(state, payload) {
    state.labelColor = { ...payload }
  },
  setEntrancesType(state, payload) {
    state.entrancesType = { ...payload }
  },
  setLabelStatus(state, payload) {
    state.labelStatus = { ...payload }
  },
  setLabelAlarmType(state, payload) {
    state.labelAlarmType = { ...payload }
  },
  setGate(state, payload) {
    state.gate = { ...payload }
  },
  setGateType(state, payload) {
    state.gateType = { ...payload }
  },
  setExpiredType(state, payload) {
    state.expiredType = { ...payload }
  },
  setStateEquipmentType(state, payload) {
    state.stateEquipmentType = { ...payload }
  },
  setDocumentType(state, payload) {
    state.documentType = { ...payload }
  },
  setDriverType(state, payload) {
    state.driverType = { ...payload }
  },
  setAreaType(state, payload) {
    state.areaType = { ...payload }
  },
  setCarVisitType(state, payload) {
    state.carVisitType = { ...payload }
  },
  setPersonVisitType(state, payload) {
    state.personVisitType = { ...payload }
  },
  setDelayedType(state, payload) {
    state.delayedType = { ...payload }
  },
  setCarModel(state, payload) {
    state.carModel = { ...payload }
  },
  setCarModelObj(state, payload) {
    state.carModelObj = { ...payload }
  },
  setDept(state, payload) {
    state.dept = { ...payload }
  },
  setNoticeType(state, payload) {
    state.noticeType = {...payload }
  },
  setNoticeStatus(state, payload) {
    state.noticeStatus = {...payload }
  },
  setUser(state, payload) {
    state.user = { ...payload }
  },
  setPlateColorType(state, payload) {
    state.plateColorType = { ...payload }
  },
  setBlackWhiteListType(state, payload) {
    state.blackWhiteListType = { ...payload }
  },
  setVehicleColorType(state, payload) {
    state.vehicleColorType = { ...payload }
  },
}
const actions = {
  setStatus({ commit }, payload) {
    commit('setStatus', payload)
  },
  setLabelType({ commit }, payload) {
    commit('setLabelType', payload)
  },
  setLabelColor({ commit }, payload) {
    commit('setLabelColor', payload)
  },
  setLabelStatus({ commit }, payload) {
    commit('setLabelStatus', payload)
  },
  setEntrancesType({ commit }, payload) {
    commit('setEntrancesType', payload)
  },
  setLabelAlarmType({ commit }, payload) {
    commit('setLabelAlarmType', payload)
  },
  setGate({ commit }, payload) {
    commit('setGate', payload)
  },
  setGateType({ commit }, payload) {
    commit('setGateType', payload)
  },
  setExpiredType({ commit }, payload) {
    commit('setExpiredType', payload)
  },
  setStateEquipmentType({ commit }, payload) {
    commit('setStateEquipmentType', payload)
  },
  setDocumentType({ commit }, payload) {
    commit('setDocumentType', payload)
  },
  setDriverType({ commit }, payload) {
    commit('setDriverType', payload)
  },
  setAreaType({ commit }, payload) {
    commit('setAreaType', payload)
  },
  setCarVisitType({ commit }, payload) {
    commit('setCarVisitType', payload)
  },
  setPersonVisitType({ commit }, payload) {
    commit('setPersonVisitType', payload)
  },
  setDelayedType({ commit }, payload) {
    commit('setDelayedType', payload)
  },
  setCarModel({ commit }, payload) {
    commit('setCarModel', payload)
  },
  setCarModelObj({ commit }, payload) {
    commit('setCarModelObj', payload)
  },
  setDept({ commit }, payload) {
    commit('setDept', payload)
  },
  setUser({ commit }, payload) {
    commit('setUser', payload)
  },
  setPlateColorType({ commit }, payload) {
    commit('setPlateColorType', payload)
  },
  setNoticeStatus({ commit }, payload) {
    commit('setNoticeStatus', payload)
  },
  setNoticeType({ commit }, payload) {
    commit('setNoticeType', payload)
  },
  setBlackWhiteListType({ commit }, payload) {
    commit('setBlackWhiteListType', payload)
  },
  setVehicleColorType({ commit }, payload) {
    commit('setVehicleColorType', payload)
  },
}
export default { state, mutations, actions }
